export default __webpack_public_path__ + "static/media/pow-7-thumb.4497924c.jpg";